<cac-dialog-layout
  [title]="data.address ? 'Edit Address' : 'Add New Address'"
  subtitle="Enter the required data and save"
  [form]="form.formGroup"
  (onSubmit)="onSubmit($event)"
>

  <div>
    <cac-form-builder [options]="form"></cac-form-builder>
  </div>
  <div class="flex gap-2 me-auto" slot="bottom">
    @if(data.address) {
      <cac-button (onClick)="onDelete($event)" theme="error">Delete Address</cac-button>
    }
  </div>
</cac-dialog-layout>
